export type McpServerStatus =
  | "running"
  | "stopped"
  | "starting"
  | "stopping"
  | "error";

export type McpStartResult = {
  success: boolean;
  errorMessage?: string;
};

export type McpStopResult = {
  success: boolean;
  errorMessage?: string;
};
